import React from 'react';

export function Greidslumat() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="112"
      height="112"
      viewBox="0 0 112 112"
    >
      <g
        id="Ársskýrsla/icon/Greiðslumat"
        fill="none"
        fillRule="evenodd"
        stroke="#163E63"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path id="Path" d="M11 80L100 80"></path>
        <path id="Path" d="M13 30L97 47"></path>
        <path id="Path" d="M90.089 46L89.911 79"></path>
        <path id="Path-Copy-3" d="M60 80L60 58 75 58 75 80"></path>
        <path id="Path-Copy-5" d="M75 41.1597189L75 35 90 35 90 45"></path>
        <path
          id="Path-Copy-4"
          d="M26.25 75.4289551L26.25 54.25 41.25 54.25 41.25 75.75"
          transform="rotate(90 33.75 65)"
        ></path>
        <path id="Path" d="M23 32L23 79"></path>
      </g>
    </svg>
  );
}
